export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-muted/30 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          <div>
            <h4 className="text-lg font-semibold">Chain Fundamentals</h4>
            <p className="mt-2 text-sm text-muted-foreground">
              Blockchain research and analytics firm specializing in real-time
              intelligence.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold">Resources</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/research" className="hover:text-foreground">
                  Research Reports
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-foreground">
                  Analytics Dashboard
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-foreground">
                  Documentation
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold">Connect</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="#" className="hover:text-foreground">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="mailto:rajiv@chainfundamentals.io" target="_blank" className="hover:text-foreground">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://forms.gle/kG4pgzxmZ7VfzHiz6" target="_blank" className="hover:text-foreground">
                  Feedback
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-border/40 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Chain Fundamentals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
